import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

const iconfont: "mdi" | "mdiSvg" | "md" | "fa" | "fa4" = "md";

const opts = {
  icons: {
    iconfont,
    values: {
      checkboxOn: 'check_circle',
      checkboxOff: 'radio_button_unchecked'
    }
  },
  theme: {
    themes: {
      light: {
        primary: "#BA324F",
        secondary: "#173D4F",
        accent: "#82b1ff"
      }
    }
  }
};

export default new Vuetify(opts);
